export default "__VITE_ASSET__DnHwIoZw__"